module.exports = __webpack_public_path__ + "img/avatar6.11324bbf.png";